import type {} from "@lit/react";
import { CrudEditColumn as CrudEditColumnElement, } from "@vaadin/crud/vaadin-crud-edit-column.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { CrudEditColumnElement, };
export type CrudEditColumnEventMap = Readonly<{}>;
const events = {} as CrudEditColumnEventMap;
export type CrudEditColumnProps = WebComponentProps<CrudEditColumnElement, CrudEditColumnEventMap>;
export const CrudEditColumn = createComponent({
    elementClass: CrudEditColumnElement, events, react: React, tagName: "vaadin-crud-edit-column"
});
